export default "__VITE_ASSET__DLoajBXo__"